import React from 'react'

const BlogDetails = () => {
  return (
    <>
         {/* <!--Start Page Header--> */}
        <section className="page-header page-header--blog-single">
            <div className="page-header__bg" style={{backgroundImage: "url(/assets/images/backgrounds/page-header-img1.jpg)"}}>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="page-header__wrapper">
                            <div className="page-header__content">
                                <h2>Expert Advice on Hardwood <br/>Floors for Homeowners</h2>
                                <div className="page-header__menu">
                                    <ul>
                                        <li><a href="/">Home</a></li>
                                        <li>Blog Single</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* <!--End Page Header--> */}



        {/* <!--Start Blog Page Single--> */}
        <section className="blog-page-single">
            <div className="container">
                <div className="row">
                    {/* <!--Start Blog Page Single Content--> */}
                    <div className="col-xl-8 col-lg-7">
                        <div className="blog-page-single__content">

                            {/* <!--Start Blog Page Two Single--> */}
                            <div className="blog-page-two__single">
                                <div className="blog-page-two__single-img">
                                    <img src="/assets/images/blog/blog-page-single-img.jpg" alt="" />
                                </div>

                                <div className="blog-page-two__single-content">
                                    <div className="blog-page-two__single-title">
                                        <p className="blog-page-two__single-tagline">HARDWOOD FLOORING</p>
                                        <h2 className="blog-page-two__single-headding">Expert Advice on Hardwood
                                            Floors <br/>for Homeowners by wood floor</h2>
                                    </div>
                                    <ul className="blog-page-two__single-meta-info">
                                        <li><i className="fa fa-calendar" aria-hidden="true"></i>November 27, 2022</li>
                                        <li><i className="fa fa-eye" aria-hidden="true"></i>300 Views</li>
                                    </ul>
                                    <p className="blog-page-two__single-text">Nulla vitae dolor eget enim accumsan aliquet.
                                        Cras lobortis feugiat ipsum quis placerat. In cursus
                                        vehicula turpis a consequat. Quisque condimentum commodo augue, at rutrum ipsum.
                                        Maecenas at viverra orci. Vestibulum vulputate placerat metus, nec feugiat
                                        libero blandit nec. Sed vitae fringilla lectus, vel consectetur augue. Nullam
                                        egestas leo non sapien placerat venenatis. Donec condimentum, libero quis
                                        facilisis pretium estibulum vulputate placerat metus</p>
                                </div>
                            </div>
                            {/* <!--End Blog Page Two Single--> */}

                            <div className="text-2">
                                <p>Donec placerat, metus vitae pharetra sollicitudin, massa erat gravida massa, nec
                                    mollis turpis justo quis quam. Suspendisse magna lacus, maximus in volutpat ac,
                                    viverra nec quam. Nulla vitae dolor eget enim accumsan aliquet. Cras lobortis
                                    feugiat ipsum by wood floor nulla vitae dolor</p>
                            </div>

                            <div className="blog-page-single__blockquote">
                                <div className="blog-page-single__blockquote-icon">
                                    <span className="icon-quotation"></span>
                                </div>

                                <div className="blog-page-single__blockquote-text">
                                    <p>“Donec placerat, metus vitae pharetra sollicitudin, massaerat gravidamassa, nec
                                        mollis turpis justo quis quam suspendisse magna lacus metus vitae pharetra’’</p>
                                    <h4 className="blog-page-single__author-name">Mahfuz Riad</h4>
                                </div>
                            </div>

                            <div className="text-3">
                                <p>Nulla vitae dolor eget enim accumsan aliquet. Cras lobortis feugiat ipsum quis
                                    placerat. In cursus
                                    vehicula turpis a consequat. Quisque condimentum commodo augue, at rutrum ipsum.
                                    Maecenas at viverra orci. Vestibulum vulputate placerat metus, nec feugiat libero
                                    blandit nec. Sed vitae fringilla lectus, vel consectetur augue. Nullam egestas leo
                                    non sapien placerat venenatis. </p>
                            </div>

                            <div className="text-4">
                                <p>If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't
                                    anything embar
                                    rassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet
                                    tend to repeat
                                    predefined chunks as necessary, making this the first true generator</p>
                            </div>

                            <div className="blog-page-single__tag-and-share">
                                <div className="left">
                                    <div className="icon">
                                        <i className="fa fa-tag" aria-hidden="true"></i>
                                    </div>
                                    <div className="text">
                                        <p>floor, house, flooring</p>
                                    </div>
                                </div>
                                <div className="right">
                                    <div className="icon">
                                        <a href="#"><i className="fa fa-share-alt" aria-hidden="true"></i></a>
                                    </div>

                                    <div className="text">
                                        <p>Share the post</p>
                                    </div>
                                </div>
                            </div>



                            <div className="blog-page-single__pagination">
                                <ul>
                                    <li>
                                        <div className="text">
                                            <h4><a href="#">Why Hardwood Flooring Has <br/>Become So Popular</a></h4>
                                        </div>

                                        <div className="icon">
                                            <a href="#"><img src="/assets/images/icon/left-arrow1.png" alt="" /></a>
                                        </div>
                                    </li>


                                    <li className="text-right">
                                        <div className="text">
                                            <h4><a href="#">Why Hardwood Flooring Has <br/>Become So Popular</a></h4>
                                        </div>

                                        <div className="icon">
                                            <a href="#"><img src="/assets/images/icon/right-arrow1.png" alt="" /></a>
                                        </div>
                                    </li>

                                </ul>
                            </div>


                            {/* <!--Start add comment box--> */}
                            <div className="add-comment-box">
                                <div className="title">
                                    <h2>Leave your thought here</h2>
                                    <p>Your email address will not be published. Required fields </p>
                                </div>
                                <form id="add-comment-form" action="#">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <input type="text" name="fname" value="" placeholder="Your Name*"
                                                        required=""/>
                                                </div>
                                                <div className="col-md-6">
                                                    <input type="email" name="form_email" value=""
                                                        placeholder="Your Email*" required=""/>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <textarea name="message" placeholder="Your Comment"
                                                        required=""></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="create-acc">
                                                <div className="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="ship-same-address"/>
                                                        <span> Save my name, email, and website in this browser for the
                                                        </span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <button type="submit" className="thm-btn blog-page-single__btn">send
                                                message <img src="/assets/images/icon/white-right-arrow.png"
                                                    alt="" /></button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            {/* <!--End add comment box--> */}
                        </div>
                    </div>
                    {/* <!--End Blog Page Single Content--> */}


                    {/* <!--Start Sidebar--> */}
                    <div className="col-xl-4 col-lg-5">
                        <div className="sidebar">
                            {/* <!--Start Single Sidebar--> */}
                            <div className="sidebar__single sidebar__categories  wow fadeInUp animated"
                                data-wow-delay="0.1s">
                                <div className="title">
                                    <h2>Categories</h2>
                                </div>
                                <ul className="sidebar__categories-link">
                                    <li className="active"><a href="#">Floor Installation <span>16</span></a>
                                    </li>
                                    <li><a href="#">Refinishing <span>07</span></a></li>
                                    <li><a href="#">Luxury Vinyl Plank <span>08</span></a></li>
                                    <li><a href="#">Door Repair <span>04</span></a></li>
                                    <li><a href="#">Interior Design <span>10</span></a></li>
                                </ul>
                            </div>
                            {/* <!--End Single Sidebar--> */}


                            {/* <!--Start Single Sidebar--> */}
                            <div className="sidebar__single sidebar__popular-stories  wow fadeInUp animated"
                                data-wow-delay="0.3s">
                                <div className="title">
                                    <h2>Popular Stories</h2>
                                </div>
                                <ul className="sidebar__popular-stories-box">
                                    <li>
                                        <div className="img">
                                            <img src="/assets/images/resources/popular-stories-img1.png" alt="" />
                                        </div>

                                        <div className="text">
                                            <h4><a href="#">The Evolution of <br/> Popular Wood Flooring <br/> Styles &
                                                    Types</a></h4>
                                            <p>Octobar 28, 2021</p>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="img">
                                            <img src="/assets/images/resources/popular-stories-img2.png" alt="" />
                                        </div>

                                        <div className="text">
                                            <h4><a href="#">The Importance of a <br/>Succession Plan for <br/>Your
                                                    Flooring Business</a></h4>
                                            <p>Octobar 28, 2021</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            {/* <!--End Single Sidebar--> */}


                            {/* <!--Start Single Sidebar--> */}
                            <div className="sidebar__single sidebar__contact-box wow fadeInUp animated"
                                data-wow-delay="0.5s">

                                <div className="services-single__sidebar-contact-info text-center">
                                    <div className="icon-bg"><img src="/assets/images/icon/phone.png" alt="" /></div>

                                    {/* <div className="icon">
                                        <span className="icon-wood-board"></span>
                                    </div> */}

                                    <h2 className="services-single__sidebar-contact-info-title">Quality Flooring at <br/> a
                                        Fair Price</h2>
                                    <p className="services-single__sidebar-contact-info-text">Call us for a FREE quote!</p>
                                    <a href="tel:666888000">(501) 103-7840</a>
                                </div>

                            </div>
                            {/* <!--End Single Sidebar--> */}
                        </div>
                    </div>
                    {/* <!--End Sidebar--> */}
                </div>
            </div>
        </section>
        {/* <!--End Blog Page Single--> */}
    </>
  )
}

export default BlogDetails